import React from 'react';

import { Loader, InvisibleText } from './SkeletonLoader.styles';

type SkeletonLoaderProps = {
  /** How far the loading swipe animation should span; preferrably exceeds width of loader */
  animationWidth?: number;
  /** Max width of loader; will span 100% of parent container if not specified */
  maxWidth?: number;
  /** Styles for further customization, e.g. media queries */
  className?: string;
};

const SkeletonLoader = ({
  animationWidth = 1920,
  maxWidth,
  className,
}: SkeletonLoaderProps): JSX.Element => {
  return (
    <Loader className={className} animationWidth={animationWidth} maxWidth={maxWidth}>
      <InvisibleText>Loading</InvisibleText>
    </Loader>
  );
};

export default SkeletonLoader;
